import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';
import { CONTACT } from './Constants';
export function StickyMobileBar() {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 z-50 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]" data-id="element-245">
      <div className="flex gap-3" data-id="element-246">
        <a href={CONTACT.whatsappUrl} target="_blank" rel="noopener noreferrer" className="flex-1 flex items-center justify-center px-4 py-3 rounded-xl text-sm font-semibold text-white bg-whatsapp active:bg-whatsapp-hover transition-colors" data-id="element-247">
          <MessageCircle className="w-5 h-5 mr-2" data-id="element-248" />
          WhatsApp
        </a>
        <a href={CONTACT.phoneUrl} className="flex-1 flex items-center justify-center px-4 py-3 rounded-xl text-sm font-semibold text-white bg-azul active:bg-azul-dark transition-colors" data-id="element-249">
          <Phone className="w-5 h-5 mr-2" data-id="element-250" />
          Llamar
        </a>
      </div>
    </div>;
}